<div
  class="text-alert border-2 p-3 flex flex-col gap-2"
  [ngClass]="{
    'bg-(--comp-snackbar-bg-normal) text-white border-(--border-primary)': data.type === 'normal',
    'bg-red-600 text-white border-red-600': data.type === 'error',
    'bg-(--comp-alert-bg) text-white border-(--border-alert)': data.type === 'alert',
  }"
>
  <div class="flex justify-between">
    <div class="flex items-center gap-4">
      {{ data.text | translate }}
    </div>
    <button matSnackBarAction (click)="snackBarRef.dismissWithAction()">
      <mat-icon>{{ data.icon }}</mat-icon>
    </button>
  </div>

  @if (data.body) {
    <div>
      <div>
        {{ data.suptext | translate }}
      </div>
    </div>
  }
</div>
